import {DataBaseHandler} from "./DataBaseHandler";
import {IngredientDataHandler} from "./IngredientDataHandler";
import {DataHandler, RewriteProps} from "./DataHandler";

export class RecipeDataHandler {
    public static recipeListeners: ((recipes: Recipe[]) => void)[] = []
    public static initIngredientSchema(db: IDBDatabase) {
        const recipesStore = db.createObjectStore("recipes", { keyPath: "name" })
        recipesStore.createIndex("ingredients", ["ingredients"], { unique: false})
        recipesStore.createIndex("description", ["description"], { unique: false})
        recipesStore.createIndex("height", ["height"], { unique: false})
        recipesStore.createIndex("diameter", ["diameterUnit"], { unique: false})
        recipesStore.createIndex("mass", ["mass"], { unique: false})
    }

    public static addRecipe(recipe: Recipe) {
        const db = DataBaseHandler.instance().db
        if (!db) return Promise.reject("No Db initialized!")
        return new DataHandler(db).add({storeName: "recipes", data: recipe}).then(val => {
            RecipeDataHandler.notifyIngredientListeners(val.currentRecords)
            return (val.requestRecord)
        })
    }

    public static updateRecipe(recipe: Recipe, oldNameToDelete?: string) {
        const db = DataBaseHandler.instance().db
        if (!db) return Promise.reject("No Db initialized!")
        return new DataHandler(db).update({storeName: "recipes", data: recipe, oldNameToDelete: oldNameToDelete}).then(val => {
            RecipeDataHandler.notifyIngredientListeners(val.currentRecords)
            return val.requestRecord
        })
    }

    public static deleteRecipe(recipe: Recipe) {
        const db = DataBaseHandler.instance().db
        if (!db) return Promise.reject("No Db initialized!")
        return new DataHandler(db).delete({storeName: "recipes", data: recipe}).then(val => {
            RecipeDataHandler.notifyIngredientListeners(val.currentRecords)
            return val.requestRecord
        })
    }

    public static getRecipes() {
        const db = DataBaseHandler.instance().db
        if (!db) return Promise.reject("No Db initialized!")
        return new DataHandler(db).get({storeName: "recipes"}).then(val => {
            return Promise.all((val.currentRecords as Recipe[])
                .map(recipe => RecipeDataHandler.recipeIngredientsCheck(recipe)))
        })
    }

    public static getRecipeByName(name: string) : Promise<Recipe> {
        const db = DataBaseHandler.instance().db
        if (!db) return Promise.reject("No Db initialized!")
        return new DataHandler(db).get({storeName: "recipes", name}).then(val => {
            const recipe = val.requestRecord as Recipe
            return RecipeDataHandler.recipeIngredientsCheck(recipe)
        })
    }

    private static recipeIngredientsCheck(recipe: Recipe): Promise<Recipe> {
        return new Promise(async (resolve, reject) => {
            const originalLength = recipe.ingredients.length
            for (let i = 0; i < recipe.ingredients.length; i++) {
                try {
                    await IngredientDataHandler.getIngredientByName(recipe.ingredients[i].name)
                } catch (reason: any) {
                    if (reason.message === "No entry found!")
                    recipe.ingredients.splice(i, 1)
                    i--
                }
            }
            if (recipe.ingredients.length === originalLength) {
                return resolve(recipe)
            }
            RecipeDataHandler.updateRecipe(recipe)
                .then(() => resolve(recipe))
                .catch(() => reject())
        })
    }

    public static rewriteAll(props: RewriteProps) {
        const db = DataBaseHandler.instance().db
        if (!db) return Promise.reject("No Db initialized!")
        return new DataHandler(db).rewrite(props).then(val => {
            console.log(val.currentRecords)
            IngredientDataHandler.notifyIngredientListeners(val.currentRecords[0])
            RecipeDataHandler.notifyIngredientListeners(val.currentRecords[1])
        })
    }

    public static notifyIngredientListeners (recipe: Recipe[]) {
        this.recipeListeners.forEach(listener => {
            listener(recipe)
        })
    }

    public static registerIngredientListener (listener: (i: Recipe[]) => void) {
        RecipeDataHandler.recipeListeners.push(listener)
    }
}
